import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=30a2d2d1&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a2d2d1",
  null
  
)

export default component.exports